export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=400f39e1db08441ad5502ae51c0314cecca4d25eea&name=revalidateCommunity!'